module.exports = __webpack_public_path__ + "static/media/loading_message.bc69589e.png";